module.exports = __webpack_public_path__ + "static/media/likee.688bc497.png";